import { useEffect, useState } from "react"
import { formatTxHash } from "utils/Helpers"
import { showErrorModal } from "utils/Modals"

type Props<T> = {
    txHash: string,
    task: () => Promise<T>,
    onSuccess: (result: T) => void,
    onError: (error: any) => void,
    onComplete: () => void
}

export function TxToast<T>({ txHash, onSuccess, onComplete, onError, task }: Props<T>) {
    const [error, setError] = useState<string | null>()
    const [seconds, setSeconds] = useState(0)

    useEffect(() => {
        const interval = setInterval(() => setSeconds(prev => prev + 1), 1000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        doTask()
    }, [])

    const doTask = async () => {
        try {
            await (new Promise((res, rej) => setTimeout(() => res(null), 8000)))
            onSuccess(await task())
            setError(null)
        } catch (e: any) {
            onError(e)
            setError(`${e}`)
        } finally {
            onComplete()
        }
    }

    function formatSeconds(seconds: number): string {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;

        const formattedMinutes = String(minutes).padStart(2, '0');
        const formattedSeconds = String(remainingSeconds).padStart(2, '0');

        return `${formattedMinutes}:${formattedSeconds}`;
    }

    return <div>
        <div
            className="bs-toast toast m-2 show bg-white"
            role="alert">

            {
                error !== undefined && <div className="toast-header">
                    <button type="button" className="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
                </div>
            }

            <div className="toast-body">
                {
                    error === undefined && <div className="badge bg-label-primary me-2 ">
                        {formatSeconds(seconds)}
                    </div>
                }

                {
                    error === null && <div className="badge bg-label-success me-2 ">
                        <i className="bx bx-check-double"></i>
                    </div>
                }

                {
                    error && <div onClick={() => showErrorModal(error)} className="badge bg-label-danger me-2 cursor-pointer">
                        <i className="bx bx-error-circle"></i>
                    </div>
                }

                <span className="fw-semibold">{formatTxHash(txHash)} <a href={`https://finder.station.money/classic/tx/${txHash}`} target="_blank" rel="noopener noreferrer"><i className="bx bx-link-external"></i></a></span>
            </div>
        </div>
    </div>
}